module.exports = __webpack_public_path__ + "assets-cabinet/img/calendar-arrow-left.247bbf0b.svg";